export const simulationActionTypes = {
	UPDATE_SIMULATION: "UPDATE_SIMULATION"
};
